import { useContext } from 'react'
import { CestaContext } from '../providers/CestaProvider'

export const useCestaOperacaoLote = () => {
  const { vestigiosSelecionados, vestigiosComCadeiaCustodia, processandoVestigiosComCadeiaCustodia, setVestigiosSelecionados, addVestigio, removerVestigio, removerListaVestigios, verificarItemEmCesta, reloadSelecionados, setReloadSelecionados, reloadListeners, setReloadListeners } = useContext(CestaContext)

  return {
    vestigiosSelecionados,
    processandoVestigiosComCadeiaCustodia,
    vestigiosComCadeiaCustodia,
    setVestigiosSelecionados,
    addVestigio,
    removerVestigio,
    removerListaVestigios,
    verificarItemEmCesta,
    reloadSelecionados,
    setReloadSelecionados,
    reloadListeners,
    setReloadListeners,
  }
}
